import styles from "./StatisticsDepositDialog.module.scss";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";
import { StatisticsDialogKeyValueItem } from "./StatisticsDialogKeyValueItem";
import { StatisticDetailItemType } from "../../../common/labels";
import {
  formatPrice,
  getAmountTone,
} from "../../../common/utilities/currencyUtility";
import { CurrencyType } from "../../../common/enums";
import { getDepositAmountWithCurrency } from "../utilities/depositAmountUtility";

interface IStatisticsDepositDebtorDialogProps {
  item: IStatisticDetailedItemViewModel;
}

// Drill-down card for the "Длъжници" and "Депозитни задължения" statistics:
// the client's name and their cross-connected-studios deposit balance —
// rendered red when negative (debtor) and green when positive (liability).
// The balance is an EUR-normalized number by contract (null currencyId = EUR).
export const StatisticsDepositDebtorDialog = ({
  item,
}: IStatisticsDepositDebtorDialogProps) => {
  const { amount: balance, currencyId } = getDepositAmountWithCurrency(
    item,
  ) ?? {
    amount: 0,
    currencyId: CurrencyType.EUR,
  };
  const tone = getAmountTone(balance);

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <div className={styles.root_header_left}>
          <h5>
            {item.userName}{" "}
            {item.userId > 0 && <span>(#{item.userId})</span>}
          </h5>
        </div>
        <div className={styles.root_header_right}>
          <span className={styles[`amount_${tone}`]}>
            {formatPrice(balance, currencyId)}
          </span>
        </div>
      </div>

      <div className={styles.root_content}>
        <StatisticsDialogKeyValueItem
          name={"БАЛАНС ПО ДЕПОЗИТ"}
          value={
            <span className={styles[`amount_${tone}`]}>
              {formatPrice(balance, currencyId)}
            </span>
          }
        />
        <StatisticsDialogKeyValueItem
          name={"ТИП"}
          value={StatisticDetailItemType[item.type]}
        />
      </div>
    </div>
  );
};
